import { atom } from 'recoil';
import { LegacyReminder } from '../../interfaces/api/Collaborative';

export default atom({
  key: 'reminders',
  default: {} as { [key: string]: LegacyReminder },
});
